// import { colors, space, radius } from "../../design/tokens";

// export default function Card({ children, style }) {
//   return (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         background: colors.surface,
//         borderRadius: radius.xl,
//         padding: space.lg,
//         ...style,
//       }}
//     >
//       {children}
//     </div>
//   );
// }

import { colors, space, radius } from "../../design/tokens";

export default function Card({ children, style, ...props }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        background: colors.surface,
        borderRadius: radius.xl,
        padding: space.lg,
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
}